<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5"/>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.2379 34.4871C28.9097 34.8152 28.4647 34.9995 28.0007 34.9995C27.5366 34.9995 27.0916 34.8152 26.7634 34.4871L16.8637 24.5874C16.5449 24.2573 16.3685 
        23.8153 16.3725 23.3564C16.3765 22.8976 16.5605 22.4587 16.885 22.1342C17.2094 21.8097 17.6484 21.6257 18.1072 21.6217C18.5661 21.6177 19.0081 21.7941 19.3382 
        22.1129L28.0007 30.7754L36.6632 22.1129C36.9932 21.7941 37.4353 21.6177 37.8941 21.6217C38.353 21.6257 38.7919 21.8097 39.1163 22.1342C39.4408 22.4587 39.6249 
        22.8976 39.6288 23.3564C39.6328 23.8153 39.4564 24.2573 39.1377 24.5874L29.2379 34.4871Z"
      fill="white"
    />
  </svg>
</template>
